import { render, staticRenderFns } from "./addressAdd.vue?vue&type=template&id=16aceb99"
import script from "./addressAdd.vue?vue&type=script&lang=js"
export * from "./addressAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports